export function useCDN(url: string): string {
  const cdn = process.env.NEXT_PUBLIC_STATIC_CDN || ''
  url = url.startsWith('/') ? url.slice(1) : url
  return cdn?.endsWith('/') ? cdn + url : cdn + '/' + url
}
